// extracted by mini-css-extract-plugin
export default {"container":"r5zgGSqMCNvxrYXLwzd0","cta":"mlHVAwXvSTGoo2_N7CpU","descriptionText":"g5IRUKHuLwdJYb2HIHGC","footer":"yC683G9Lte56RGNuoy0T"};